import React from "react";
import Header from "../components/Home/Header";
import Tags from "../components/Meta/Tags";
import Services from "../components/Home/Services";
import MedicCenters from "../components/Home/MedicCenters";
import Portals from "../components/Home/Portals";
import GoogleReviews from "../components/Home/ReviewsCard";
const Home = () => (

  <>
    <Tags 
    title="Prepaga médica en CABA | Planes accesibles " 
    description="Sumate a Alta Salud: prepaga sin carencias, sin edad límite y con atención rápida en CABA. Planes médicos accesibles y respuesta inmediata." 
    keywords="Prepaga de salud, Obra social, Cobertura medica, Prestadores medicos,Atencion primaria, Guardia, Servicios medicos, Turnos online, Portal de gestion, Centros medicos propios, Planes de salud, Cartilla medica" 
    canonical="/" />
    <Header />
    <Services />
    <MedicCenters />
    <GoogleReviews/>
    <Portals /> 
  </>
);

export default Home;
